// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC, Fragment, useState, useMemo, useEffect, useRef } from "react";
// Components:
// import DivE from "./DivE.tsx";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getDict, getAllApps, setXMLtoApp, setAppState, setAppJSON, clearAppJSON } from "../../libs/reducer.ts";
// Types
import type {Tapp} from "../../types/uiapp.d.ts";

import fnc from "../../libs/fnc.ts";
import uigen from "../../libs/uigen.tsx";

// const stopDoubleAction = {loadXML: false, loadScripts: false};

const LoadingSpinner = (<div className="uk-flex uk-flex-center uk-flex-middle rz-borders-l4 content-fixed" style={{height: "100%"}}><div className="loader05"></div></div>);

const NotFoundContent:FC = (msg:string) => (
  <div className="uk-flex uk-flex-center uk-flex-middle" style={{height: "100%"}}>
    <h5 className="uk-margin-remove uk-text-center txt-white txt-stroke-black-shadow">{msg}</h5>
  </div>
);

const ErrorContent:FC = (msg:string) => (
  <div className="uk-flex uk-flex-center uk-flex-middle" style={{height: "100%"}}>
    <h5 className="uk-margin-remove uk-text-center txt-white txt-stroke-red-shadow">{msg}</h5>
  </div>
);

type componentProps = { wapp:Tapp };

// const {rz} = window;

const OneDesktopWidget:FC<componentProps> = ({wapp}) => {
  const dispatch = useAppDispatch();
  const allApps = useAppSelector(getAllApps);
  const dct = useAppSelector(getDict);
  const lng = useAppSelector(getLng);

  const app = useMemo<Tapp | undefined>(() => (allApps && allApps.find((aa) => (aa.key === wapp.key))), [allApps, wapp.key]);

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [startRender, setStartRender] = useState(false);
  const [finishRender, setFinishRender] = useState(false);
  const [rootAttributes, setRootAttributes] = useState<{[key:string]: any}>({});

  const cntRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!app) { return }
    setStartRender(false); setFinishRender(false); setErrorMessage(""); setLoading(true);

    if (!app.templateXML) {
      // if (!stopDoubleAction.loadXML) {
      // stopDoubleAction.loadXML = true; setTimeout(() => { stopDoubleAction.loadXML = false }, 1000);
      fnc.loadPage(app).then((ans1) => {
        if (ans1.err) { setErrorMessage(ans1.err); console.log(ans1.err); setLoading(false) }
        else if (ans1.result && ans1.app && ans1.app.templateXML) {
          dispatch(setXMLtoApp(ans1.app));
          dispatch(clearAppJSON(ans1.app.key));
        }
      });
      // }
      return;
    }

    // if (!stopDoubleAction.loadScripts) {
    // stopDoubleAction.loadScripts = true; setTimeout(() => { stopDoubleAction.loadScripts = false }, 1000);
    // Dynamically load linked javascripts
    fnc.dynamicallyLoadScripts(app).then((ans2) => {
      // eslint-disable-next-line max-len
      // if (fnc.config?.isDev) rz.log({message: "fnc.dynamicallyLoadScripts(): " + (ans2.scripts || []).join(", "), module: "PageConstructor.tsx", caller: "<PageConstructor> -> useEffect()[app] -> fnc.loadPage(app)"});
      if (ans2.err) { setErrorMessage(ans2.err); console.log(ans2.err); setLoading(false) }
      else { setTimeout(() => { setStartRender(true) }, 500) }
    });
    // }
  }, [app, dispatch]);

  // if (app?.key === "systemlogs_widget") { console.log({app, loading, startRender, finishRender}) }

  useEffect(() => {
    if (!app || finishRender || (!startRender || !app.templateXML)) return;
    // =========================================
    // Conver XML-DOM to React-DOM
    const ans1 = uigen.ConvertXMLtoJSON(app.templateXML);
    if (ans1.result) {
      if (ans1.rootAttributes && ans1.rootAttributes.key) {
        setRootAttributes(ans1.rootAttributes);
        if (ans1.elements) {
          // =============== GLOBAL APP JSON ================
          dispatch(setAppJSON({appkey: ans1.rootAttributes.key, newJSON: ans1.elements}));
          // =============== GLOBAL APP STATE ===============
          const newState = uigen.buildUIstate(ans1.elements, ans1.rootAttributes);
          dispatch(setAppState({appkey: ans1.rootAttributes.key, newState}));
          // ================================================
          setFinishRender(true); setLoading(false);
        }
        else { setErrorMessage("<template>...EMPTY OR UNKNOWN ELEMENTS...</template>"); setLoading(false) }
      }
      else { setErrorMessage("Missing 'key' attribute in the root element: <template key='???????'></template>"); setLoading(false) }
    }
    else { setErrorMessage(ans1.err || dct.e.unknowErrorWhileReactElementsBuilding); setLoading(false) }

    // =========================================
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app, startRender, dct, lng]);

  const pageConstructorContent = useMemo(() => (
    <uigen.GeneratePage rootAttributes={rootAttributes} />
  ), [rootAttributes]);

  const widgetSkelet = (elmns:any) => (
    <div key={app!.key + "-container"} id={app!.key + "-container"} ref={cntRef} className="widget-container" style={{width: "100%", height: "100%"}} >
      <style>
        { // @ts-ignore
          ":root{--widget-" + app.key + "-height: " + (cntRef?.current?.clientHeight ?? 0) + "; --widget-" + app.key + "-width: " + (cntRef?.current?.clientWidth ?? 0) + ";}"
        }
      </style>
      {elmns}
    </div>
  );

  if (!app) return NotFoundContent(dct.e.pageNotfoundOrDenied);
  if (loading) return widgetSkelet(LoadingSpinner);
  if (errorMessage) return widgetSkelet(ErrorContent(errorMessage));

  return widgetSkelet(
    <Fragment key={rootAttributes?.key || app?.key}>
      {pageConstructorContent}
    </Fragment>
  );
}

export default OneDesktopWidget;
